
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import GET_TITLES from "@/apollo/autocomplete-queries/GetTagTitles.gql";
  import DropdownOption from "@/entities/DropdownOption";
  import {Query_RootUser_ProfileArgs } from "@/generated/graphql";

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      titles: {
        query: GET_TITLES,
        variables() {
          return this.titleAutocompleteFilter;
        },
        update(data) {
          return data.tag;
        },
        skip() {
          return !this.titleSearchString;
        },
      },
    },
  })

  export default class TitlesMultiselect extends Vue {
    @Prop({required: true, type: Array}) value!: DropdownOption[];
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
    @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;
  @Prop({ type: String, default: "Select Titles" }) readonly placeholder?: string;

    titles: DropdownOption[] = [];
    titleSearchString = "";
  get placeholderText(): string {
    return this.placeholder;
  }
    get mappedTitleValue(): String[] {
      return this.value.map((item) => item.name);
    }

    get titleAutocompleteFilter(): Query_RootUser_ProfileArgs {
      const conditions: any[] = [
        { 
          name: { 
            _ilike: `%${this.titleSearchString}%`
          }, 
        },
        { 
          name: {
            _is_null: false } 
        },
      ]; 

      if (this.mappedTitleValue.length) {
        conditions.push(
          {
            name: { 
              _nin: this.mappedTitleValue 
            }, 
          },
        );
      }
      return {
        where: { _and: conditions },
        limit: 5,
      };
    }

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val)
    }
  }
